<template>
  <div class="container sidebarLayout">
    <div class="orderCenter">
      <a-spin :spinning="spinning">
        <Title title="订单中心" />

        <div class="search">
          <a-input
            class="ipt"
            v-model="orderCode"
            placeholder="输入订单编号搜索"
          />
          <a-button
            class="btn btns"
            @click="getOrderInfos"
            type="primary"
          >
            查询
          </a-button>
          <a-button
            @click="rest"
            class="btn btn_a"
          >
            重置
          </a-button>
        </div>
        <div class="container">
          <div />
          <div class="table">
            <a-table
              :columns="selectcolumns"
              :scroll="{ x:960, y: 640 }"
              :pagination="false"
              :data-source="data"
              bordered
            >
              <span
                slot="statusStr"
                slot-scope="state"
              >{{ guaranteeStateList[String(state)].label }}</span>
              <span
                slot="createTimeStr"
                slot-scope="createTime"
              >{{ dateFormat(createTime) }}</span>
              <span
                slot="action"
                slot-scope="space, text"
              >
                <a
                  class="look_btn"
                  @click="Look(text)"
                >查看</a>
                <a
                  class="look_btn"
                  @click="downloadBh(text.guaranteeDownloadUrl)"
                  v-if="text.guaranteeDownloadUrl&&(text.status!=31)&&(text.status!=33)"
                >下载保函</a>
                <a
                  class="look_btn"
                  @click="downloadBh(text.invoiceUrl)"
                  v-if="text.invoiceUrl"
                >下载发票</a>
                <a
                  class="look_btn"
                  @click="tuibao(text)"
                  v-if="text.isInsureCancel&&text.surrenderBut"
                >退保</a>
                <a
                  class="look_btn"
                  @click="viewBh"
                  v-if="text.state === '3'"
                >预览保函</a>
                <a
                  class="look_btn"
                  v-if="text.status=='1'||text.status=='2'||text.status=='7'||text.status=='11'"
                  @click="cancle(text)"
                >取消</a>
              </span>
            </a-table>
          </div>
          <div class="page">
            <span class="text">总共 {{ total }} 条记录</span>
            <a-pagination
              v-model="page"
              :total="total"
              show-size-changer
              :page-size="size"
              @showSizeChange="onShowSizeChange"
              class="page_list"
            >
              <template
                slot="buildOptionText"
                slot-scope="props"
              >
                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
              </template>
            </a-pagination>
          </div>
        </div>
      </a-spin>
      <!-- 退保 -->
      <a-modal
        v-model="visible"
        :title="isBtnStr"
        @ok="submit"
        :mask-closable="false"
        ok-text="确认"
        cancel-text="取消"
        class="Invoicing"
      >
        <a-form
          :form="modalform"
          :label-col="{ span: 9 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-form-item
            label="业务流水号"
            v-if="isBtnStr === '退保'"
          >
            <span>{{ modaldata.applyNo }}</span>
          </a-form-item>
          <a-form-item
            label="手机号"
            v-if="isBtnStr !== '开票'"
          >
            <span>{{ modaldata.mobile }}</span>
          </a-form-item>
          <div v-if="isBtnStr === '退保'">
            <a-form-item label="投标人名称">
              <span>{{ modaldata.name }}</span>
            </a-form-item>
            <a-form-item label="投标人统一社会信用代码">
              <span>{{ modaldata.creditCode }}</span>
            </a-form-item>

            <a-form-item label="退保原因">
              <a-select
                v-decorator="[
                  'cancelReason',
                  { rules: [{ required: true, message: '请选择退保原因' }] }
                ]"
                style="width: 275px"
              >
                <a-select-option value="项目未开标，不想投标了">
                  项目未开标，不想投标了
                </a-select-option>
                <a-select-option value="投标人失误，或选择投标项目错误">
                  投标人失误，或选择投标项目错误
                </a-select-option>
                <a-select-option value="因项目变化等其他原因">
                  因项目变化等其他原因
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div v-if="isBtnStr === '开票'">
            <a-form-item label="发票抬头">
              <span>{{ data.invoiceType }}</span>
            </a-form-item>
            <a-form-item label="纳税人识别号">
              <span>{{ data.creditCode }}</span>
            </a-form-item>
            <a-form-item label="手机号">
              <span>{{ data.mobile }}</span>
            </a-form-item>
            <a-form-item label="发票类型">
              <a-select
                v-model="invoiceType"
                style="width: 275px"
              >
                <a-select-option value="2">
                  电子(普票)
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="开户行">
              <a-input
                v-decorator="[
                  'bankInfo',
                  { rules: [{ required: true, message: '请输入开户行' }] }
                ]"
                placeholder="请输入开户行"
                style="width: 275px"
              />
            </a-form-item>
            <a-form-item label="开户账号">
              <a-input
                v-decorator="[
                  'bankAcc',
                  { rules: [{ required: true, message: '请输入开户账号' }] }
                ]"
                placeholder="请输入开户账号"
                style="width: 275px"
              />
            </a-form-item>
            <a-form-item label="联系电话">
              <a-input
                v-decorator="[
                  'phoneNo',
                  { rules: [{ required: true, message: '请输入联系电话' }] }
                ]"
                placeholder="请输入联系电话"
                style="width: 275px"
              />
            </a-form-item>
            <a-form-item label="邮箱">
              <a-input
                v-decorator="[
                  'email',
                  { rules: [{ required: true, message: '请输入邮箱' }] }
                ]"
                placeholder="请输入邮箱"
                style="width: 275px"
              />
            </a-form-item>
            <a-form-item label="注册地址">
              <a-input
                v-decorator="[
                  'addInfo',
                  { rules: [{ required: true, message: '请输入注册地址' }] }
                ]"
                placeholder="请输入注册地址"
                style="width: 275px"
              />
            </a-form-item>

            <a-form-item label="备注">
              <a-input
                v-decorator="['remark', { rules: [{}] }]"
                placeholder="请输入备注"
                style="width: 275px"
              />
            </a-form-item>
          </div>
        </a-form>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Title from '@/components/Title/index.vue';
import api from './api';
import { dictDetail } from '@/api/performance.js';
import { dateFormat } from '@/utils/format.js';
import {
  code,
  phoneCode,
  insureCancel,
  insureInvoice,
  giveupapply,
} from '@/api/insure.js';
const columns = [
  {
    title: '订单编号',
    dataIndex: 'thirdOrderCode',
    width: 180,
    ellipsis: true,
    key: 'thirdOrderCode',
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis: true,
    width: 140,
    key: 'projectName',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    ellipsis: true,
    width: 140,
    key: 'projectCode',
  },
  {
    title: '标段名称',
    dataIndex: 'sectionName',
    key: 'sectionName',
  },
  {
    title: '标段编号',
    dataIndex: 'sectionCode',
    key: 'sectionCode',
  },
  {
    title: '担保保额(元)',
    dataIndex: 'sumAmount',
    ellipsis: true,
    key: 'sumAmount',
  },
  {
    title: '担保保费(元)',
    dataIndex: 'sumPremium',
    ellipsis: true,
    key: 'sumPremium',
  },
  {
    title: '担保状态',
    dataIndex: 'statusStr',
    key: 'statusStr',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 220,
    scopedSlots: { customRender: 'action' },
  },
];
const columnsB = [
  {
    title: '订单编号',
    dataIndex: 'thirdOrderCode',
    width: 180,
    ellipsis: true,
    key: 'thirdOrderCode',
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis: true,
    width: 140,
    key: 'projectName',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    ellipsis: true,
    width: 140,
    key: 'projectCode',
  },
  {
    title: '标段名称',
    dataIndex: 'sectionName',
    key: 'sectionName',
  },
  {
    title: '标段编号',
    dataIndex: 'sectionCode',
    key: 'sectionCode',
  },
  {
    title: '担保保额(元)',
    dataIndex: 'sumAmount',
    ellipsis: true,
    key: 'sumAmount',
  },
  {
    title: '担保保费(元)',
    dataIndex: 'sumPremium',
    ellipsis: true,
    key: 'sumPremium',
  },
  {
    title: '担保状态',
    dataIndex: 'statusStr',
    key: 'statusStr',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 220,
    scopedSlots: { customRender: 'action' },
  },
];
const data = [];
export default {
  components: { Title },
  data() {
    return {
      dateFormat,
      data,
      columns,
      selectcolumns: [],
      size: 10,
      page: 1,
      total: 0,
      pageSizeOptions: [ '1', '15', '20' ],
      orderCode: '',
      creditCode: '',
      center: '',
      productCode: '',
      spinning: false,
      guaranteeStateList: [],
      projectNatureList: [],
      guaranteeAptitudeList: [],
      guaranteeAptitudeLevelList: [],
      backletterFormatList: [],
      guaranteeProductList: [],
      isBtnStr: '退保',
      isVisBtn: false,
      visible: false,
      modalform: this.$form.createForm(this, { name: 'modalform' }),
      uuid: '',
      codeImg: '',
      isTime: true,
      time: 60,
      modaldata: {
        mobile: '',
      },
    };
  },
  watch: {
    size() {
      this.getOrderInfos();
    },
    page() {
      this.getOrderInfos();
    },
  },
  mounted() {
    this.getUrlParams();
    this.getDictDetail();
    this.getOrderInfos();
  },
  methods: {
    cancle(text) {
      const that = this;
      const paramsA = {
        orderNo: text.applyNo,
      };
      this.$confirm('请确认是否取消投保', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning', // 可选: success/error/info/warning
      }).then(() => {
        giveupapply(paramsA).then(res => {
          if (res.data.status === 200) {
            that.$notification.success({ message: '取消成功' });
          }
          that.getOrderInfos();
        });

      }).catch(() => {
      });
    },
    getUrlParams() {
      // 获取 URL 参数
      const urlParams = new URLSearchParams(window.location.search);
      this.creditCode = urlParams.get('creditCode');
      this.center = urlParams.get('center');
      console.log(this.creditCode, this.center);
    },

    getDictDetail() {
      dictDetail({ dictName: 'guaranteeState' }).then(res => {
        this.guaranteeStateList = res.data.data;
      });
      dictDetail({ dictName: 'projectNature' }).then(res => {
        this.projectNatureList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitude' }).then(res => {
        this.guaranteeAptitudeList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeAptitudeLevel' }).then(res => {
        this.guaranteeAptitudeLevelList = res.data.data;
      });
      dictDetail({ dictName: 'backletterFormat' }).then(res => {
        this.backletterFormatList = res.data.data;
      });
      dictDetail({ dictName: 'guaranteeProduct' }).then(res => {
        this.guaranteeProductList = res.data.data;
      });
    },
    //
    getOrderInfos() {
      this.spinning = true;
      const params = {
        size: this.size,
        page: this.page,
      };
      if (this.orderCode) {
        params.orderCode = this.orderCode;
      }
      params.creditCode = this.creditCode;
      params.center = this.center;
      api.getCenterApplyInfos(params).then(({ data: data }) => {
        this.selectcolumns = columnsB;
        this.data = data.data.content;
        this.total = data.data.totalElements;
        this.spinning = false;
        console.log(data);
      });
    },
    onShowSizeChange(current, pageSize) {
      this.size = pageSize;
    },
    Look(row) {
      window.open(row.jumpUrl);
    },
    rest() {
      this.orderCode = '';
      this.page = 1; // 重置到第一页
      this.getOrderInfos();
    },
    downloadBh(url) {
      // .replace('/download','/readFile')
      window.open(encodeURI(url), '_blank');
      // downloadUrl
      // var a = document.createElement("a"); //创建一个<a></a>标签
      //     a.href = "/static/downloadView.pdf"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      //     a.download = "保函.pdf"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      //     a.style.display = "none"; // 障眼法藏起来a标签
      //     document.body.appendChild(a); // 将a标签追加到文档对象中
      //     a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      //     a.remove(); // 一次性的，用完就删除a标签
    },
    viewBh() {
      const pdfUrl = 'static/downloadView.pdf';
      window.open(pdfUrl);
    },
    tuibao(text) {
      this.isBtnStr = '退保';
      this.visible = true;
      this.modaldata = text;
    },
    submit() {
      this.modalform.validateFields(err => {
        if (!err) {
          if (this.isBtnStr === '退保') {
            const params = {
              responsiblePersonPhone: this.modaldata.mobile,
              orderNo: this.modaldata.applyNo,
              cancelReason: this.modalform.fieldsStore.fields.cancelReason.value,
            };
            console.log(params);
            insureCancel(params)
              .then(res => {
                console.log(res);
                if (res.status === 200) {
                  this.$notification.success({ message: res.data.message });
                  this.getOrderInfos();
                  this.visible = false;
                } else {
                  this.$notification.warning({ message: res.data.message });
                }
              })
              .catch(err => {
                this.$notification.error({ message: err.respomessage });
              });
          } else if (this.isBtnStr === '开票') {
            console.log(this.modalform.fieldsStore.fields);
            const params = {
              responsiblePersonPhone: this.modaldata.mobile,
              orderNo: this.orderNo,
              // phoneCode: this.form.fieldsStore.fields.phoneCode.value,
              invoiceType: this.invoiceType,
              // invoiceHead: this.form.fieldsStore.fields.invoiceHead.value,
              // cuscCode: this.form.fieldsStore.fields.cuscCode.value,
              invoiceHead: this.modaldata.name,
              cuscCode: this.modaldata.creditCode,
              bankInfo: this.modalform.fieldsStore.fields.bankInfo.value,
              bankAcc: this.modalform.fieldsStore.fields.bankAcc.value,
              phoneNo: this.modalform.fieldsStore.fields.phoneNo.value,
              addInfo: this.modalform.fieldsStore.fields.addInfo.value,
              email: this.modalform.fieldsStore.fields.email.value,
              // addressee:this.form.fieldsStore.fields.addressee.value,
              // addresseePhone:this.form.fieldsStore.fields.addresseePhone.value,
              // email:this.form.fieldsStore.fields.email.value,
              // address:this.form.fieldsStore.fields.address.value,
              remark: this.modalform.fieldsStore.fields.remark.value,
              invoiceStatus: '0',
            };
            insureInvoice(params).then(res => {
              if (res.data.status === 200) {
                this.$notification.success({ message: res.data.message });
                this.visible = false;
                this.getOrderInfos();
              } else {
                this.$notification.warning({ message: res.data.message });
              }
            });
          }
        }
      });
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
      });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = '';
      console.log(this.modalform.instances);
      if (this.modalform.instances.code.stateValue !== '') {
        phoneCode({
          codeKey: this.uuid,
          code: this.modalform.instances.code.stateValue,
          phoneNum: this.modaldata.mobile,
        }).then(res => {
          if (res.status === 200) {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning('图形验证码不为空');
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.orderCenter {
  width: 100%;
  min-height: 940px;
  padding: 20px;
  .search {
    display: flex;
    margin: 20px 0;
    .ipt {
      width: 300px;
      height: 32px;
    }
    .btn {
      width: 80px;
      height: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
    }
    .btns {
      background: #0E52D4;
      border: none;
      margin-left: 15px;
      margin-right: 0;
    }
    .btn_a {
      border: 1px solid #0E52D4;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #0E52D4;
      margin-left: 10px;
    }
  }
  .table {
    ::v-deep.ant-table-thead > tr > th {
      font-size: 14px !important;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400 !important;
      color: #333333 !important;
      background: rgba(0, 92, 168, 0.05) !important;
    }
    .p_text {
      position: relative;
      .p_red {
        width: 6px;
        height: 6px;
        background: #0E52D4;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_blue {
        width: 6px;
        height: 6px;
        background: #bae7ff;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_or {
        width: 6px;
        height: 6px;
        background: #0E52D4;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_gree {
        background: #aff0b5;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
      .p_h {
        background: #e9e9e9;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        position: absolute;
        left: -10px;
        top: 7px;
      }
    }
  }

  ::v-deep .ant-tabs-bar {
    border-bottom: none !important;
  }
  ::v-deep .ant-tabs-tab {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  ::v-deep .ant-tabs-nav .ant-tabs-tab-active {
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0E52D4;
  }
  ::v-deep .ant-tabs-ink-bar {
    background: #0E52D4;
  }
  ::v-deep .ant-tabs-nav .ant-tabs-tab {
    padding: 10px 12px 20px 12px;
    text-align: center;
  }
  ::v-deep .ant-tabs-bar {
    margin: 0 0 3px 0;
  }
  a {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #0E52D4;
  }
  .page {
    margin-top: 20px;
    position: relative;
    // display: flex;
    .page_list {
      text-align: right;
    }
    .text {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 7px;
      left: 0;
    }
  }
}

::v-deep .ant-tabs-nav .ant-tabs-tab {
  margin: 0px 12px 0 0;
}
::v-deep .ant-btn {
  border-color: #0E52D4 !important;
}
.look_btn {
  margin-right: 10px;
}

.orderCenter .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  background: #0E52D4;
  border-color: #0E52D4;
}
.orderCenter .ant-radio-group{
  margin-bottom: 20px;
}


.orderCenter ::v-deep .ant-modal {
  width: 760px !important;
}

::v-deep .ant-modal-content {
  width: 760px !important;
  height: 616px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

.Invoicing ::v-deep .ant-modal-content {
  width: 700px !important;
  height: auto !important;
  min-height: 420px;
  padding: 40px 50px 24px;
}

.Invoicing ::v-deep .ant-form-item {
  margin-bottom: 12px !important;
}

.Invoicing ::v-deep .ant-form-item-label {
  text-align: right !important;
  padding-left: 0 !important;
}

.Invoicing ::v-deep .ant-form label {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.447);
}

.Invoicing ::v-deep .ant-form-item-children {
  display: block;
  max-width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: rgb(51, 51, 51);
  vertical-align: middle;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}
.code {
  img {
    position: absolute;
    cursor: pointer;
    left: 180px;
    top: -5px;
    height: 30px;
  }

  a,
  span {
    position: absolute;
    width: 80px;
    left: 192px;
  }
}
::v-deep .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 0;
}
</style>
